export default __webpack_public_path__ + "static/media/logo96x96.71ca179d.jpg";